import { createReducer } from '../utils/misc';

import {
    FETCH_VERSION_REQUEST,
    RECEIVE_VERSION,
    RECEIVE_VERSION_ERROR,
} from '../constants/index'


const initialState = {
    data: null,
    isFetching: false,
    loaded: false,
    message_text: null,
    message_open: false,
    error: false,
    frontend: null,
    api: null,
};

export default createReducer(initialState, {
    [FETCH_VERSION_REQUEST]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: true,
            message_text: payload.message,
        }),

    [RECEIVE_VERSION]: (state, payload) =>
        Object.assign({}, state, {
            data: payload.data,
            frontend: payload.data.frontend,
            api: payload.data.api,
            isFetching: false,
            loaded: true,
            message_text: payload.message,
        }),

    [RECEIVE_VERSION_ERROR]: (state, payload) =>
        Object.assign({}, state, {
            error: true,
            loaded: false,
            isFetching: false,
            message_text: payload.message,
            message_open: true,
        }),
});
